import { ApiSlugs, UserSessionCoreDto, UserSessionId } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../api-caller.service';
import { ApiConnector } from '../../api-connector.abstract-service';

export class UserSessionsConnector extends ApiConnector<
  UserSessionCoreDto,
  UserSessionCoreDto,
  UserSessionId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.USER_SESSIONS);
  }

  mySessions(): Observable<UserSessionCoreDto[]> {
    return this.apiCaller.getRequest<UserSessionCoreDto[]>(this.apiPrefix, `${this.slug}`);
  }

  start(): Observable<void> {
    return this.apiCaller.postRequest<void>(this.apiPrefix, `${this.slug}/start`);
  }

  revoke(userSessionId: UserSessionId): Observable<void> {
    return this.apiCaller.postRequest<void>(this.apiPrefix, `${this.slug}/revoke/${userSessionId}`);
  }

  revokeImpersonate(): Observable<void> {
    return this.apiCaller.postRequest<void>(this.apiPrefix, `${this.slug}/revoke-impersonate`);
  }

  revokeAllSessions(): Observable<void> {
    return this.apiCaller.postRequest<void>(this.apiPrefix, `${this.slug}/revoke-all`);
  }
}
